import { createAction, createReducer } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: false,
  loading: false,
  payments: [],
};

const paymentsRequest = createAction("paymentsRequest");
const paymentsSuccess = createAction("paymentsSuccess");
const paymentsFailure = createAction("paymentsFailure");

export const paymentsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(paymentsRequest, (state, action) => {
      state.loading = true;
    })
    .addCase(paymentsSuccess, (state, action) => {
      state.loading = false;
      state.payments = action.payload;
    })
    .addCase(paymentsFailure, (state, action) => {
      state.loading = false;
      state.payments = [];
    }); });        